import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, User } from "lucide-react";
import api from "@/lib/api";

// Mini top-5 leaderboard for a single venue (matched by city name in results).
export default function VenueLeaderboard({ venueName }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!venueName) return;
    api.get(`/leaderboards?venue=${encodeURIComponent(venueName)}`).then((r) => setRows(r.data.slice(0, 5))).catch(() => {});
  }, [venueName]);

  const avatar = (p) => (p ? (p.startsWith("http") ? p : `${process.env.REACT_APP_BACKEND_URL}${p}`) : "");
  if (rows.length === 0) return null;

  return (
    <div className="mt-4 pt-4 border-t border-white/5" data-testid={`venue-board-${venueName}`}>
      <div className="flex items-center gap-1.5 text-gold text-[10px] uppercase tracking-[0.25em] mb-3">
        <Trophy className="w-3.5 h-3.5" /> Local Top 5
      </div>
      <ol className="space-y-1.5">
        {rows.map((r) => (
          <li key={r.player_name} className="flex items-center gap-2.5 text-sm">
            <span className="w-4 text-slate-500 font-display font-bold">{r.rank}</span>
            <span className="w-6 h-6 rounded-full overflow-hidden bg-navy border border-white/10 flex items-center justify-center flex-shrink-0">
              {avatar(r.picture) ? <img src={avatar(r.picture)} alt="" className="w-full h-full object-cover" /> : <User className="w-3 h-3 text-slate-500" />}
            </span>
            <Link to={`/players/${encodeURIComponent(r.player_name)}`} className="text-slate-200 hover:text-gold transition-colors flex-1 truncate">{r.player_name}</Link>
            <span className="text-gold font-semibold">{r.points}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
